import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  width: '160px',
  borderRadius: '4px',
  backgroundColor: '#081c42',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#0c2658',
    textTransform: 'none',
  },
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontWeight: 'bold',
}));

export default function ButtonRequest(prop) {
  return (
    <ColorButton endIcon={prop.loading ? <CircularProgress size={12}/> : <SendIcon />} variant="contained" type="submit" disabled={prop.disabled}>{prop.name}</ColorButton>
  );
}